/**
 * Builds an object that holds ids of the given activities, partitioned by
 * their activity type
 *
 * @param {Object[]} activities An array of activity models
 * @return {Object}
 * @property {number[]} competition_ids An array of ids for the competitions
 * @property {number[]} survey_ids An array of ids for the surveys
 * @property {number[]} poll_ids An array of ids for any other type of activity
 */
export default function (activities) {
  const data = {
    competition_ids: [],
    poll_ids: [],
    survey_ids: []
  }

  activities.forEach((activity) => {
    switch (activity.type()) {
      case 'competition':
        data.competition_ids.push(activity.id)
        break

      case 'survey':
        data.survey_ids.push(activity.id)
        break

      default:
        data.poll_ids.push(activity.id)
    }
  })

  return data
}
